import type { IImageLoader } from "@Components/ImageLoader";
import type { ILink } from "@Components/Link";

import type { INavigationModalActionsField } from "../common/NavigationModal";
import type { IUserCommunicationTemplate } from "../common/UserCommunicationTemplate";

export enum CashbackClaimType {
    Undefined = 0,
    Cashback = 1,
    Visa = 2,
}
export interface ICashbackClaimFields extends INavigationModalActionsField {
    transactionId?: string;
    purchaseAmount?: string;
    purchaseAmountValue?: number;
    cashbackAmount?: string;
    cashbackAmountValue?: number;
    cashbackNewAmount?: string;
    cashbackNewAmountValue?: number;
    date?: string;
    dateFormat?: Date;
    brandName?: string;
    brandId?: string;
    imageUrl?: string;
    orderId?: string;
    availability?: AvailabilityState;
    type?: ComplaintType;
    cashbackClaimType?: CashbackClaimType;
    visaChannelType?: VisaChannelType;
    communicationTemplate?: IUserCommunicationTemplate;
}

export type VisaChannelType = "Undefined" | "Online" | "Offline";

export enum AvailabilityState {
    Unknown, // Withdrawal
    Pending,
    Approved,
    Rejected,
}

export type ComplaintType =
    | "Unknown"
    | "CashbackRejected"
    | "IncorrectCashback"
    | "MissingTransaction"
    | "MissingVisaTransaction";

export enum ElementType {
    BrandDetails,
    TransactionList,
    MemberGetMember,
    Help,
    Url,
}

export interface ICashbackBannerElement {
    imageUrlDesktop?: string;
    imageUrlTablet?: string;
    imageUrlMobile?: string;
    link?: ILink;
    title?: string;
    clickAction?: ElementType;
    id?: string;
    bannerViewTrackerUrl?: string;
}

export interface ICashbackAdBanner extends INavigationModalActionsField {
    banner?: ICashbackBannerElement;
}

export enum CashbackComplaintStatus {
    Unknown,
    Pending,
    Approved,
    Rejected,
}

export interface ISpecialCashback {
    id: string;
    maxCashback: string;
    dateFrom: string;
    dateTo: string;
    maxUsageCount?: number;
    maxCashbackLimit?: number;
    overrideSegmentMaxCashback: boolean;
    infoForUser?: number;
    url?: string;
}

export interface ICashbackBrandsByCategory {
    initialData: string[];
    categoryKey: string;
}

export interface ICashbackBrandTile {
    id: string;
    image: IImageLoader;
    href: string;
    telemetryAction: string;
    description?: string;
    subDescription?: string;
    secondSubDescription?: string;
    transactionCount: number;
    specialCashback?: ISpecialCashback;
    specialCashbackTimeLimit?: string;
}

export type ICashbackBrandTileDictionary = { [key: string]: ICashbackBrandTile };
